import { User, UserRole } from '@/types/user';

export const isInvestor = (user: User | null): boolean => {
  if (!user) return false;
  return user?.user_role === UserRole.INVESTOR_INDIVIDUAL || user?.user_role === UserRole.INVESTOR_COMPANY;
};

export const isBorrower = (user: User | null): boolean => {
  if (!user) return false;
  return user?.user_role === UserRole.BORROWER;
};

export enum UserFormTypeRole {
  BORROWER = 'borrower',
  INVESTOR = 'investor',
}

export const getUserRoleDisplayName = (userRole: UserFormTypeRole | null): string => {
  switch (userRole) {
    case UserFormTypeRole.INVESTOR:
      return 'Investor';
    case UserFormTypeRole.BORROWER:
      return 'Borrower';
    default:
      return '';
  }
};
